import { OutboxStatusEnum } from '../../../platform/outbox/enums/outbox-status.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';

/**
 * Notification log DTO for records
 */
@CaslSubject(AppSubjectEnum.NOTIFICATION_LOG)
export class NotificationLogRecordDto extends BaseDto {
	/**
	 * Audit log ID
	 */
	auditLogId!: number;

	/**
	 * User ID
	 */
	userId!: number;

	/**
	 * Notification channel
	 */
	channel!: DataDispatchChannelEnum;

	/**
	 * Status of the record
	 */
	status!: OutboxStatusEnum;

	/**
	 * Composite key describing the event and action that triggered the notification
	 */
	key!: string;

	/**
	 * Source subject of the message
	 */
	subject!: AppSubjectEnum;

	/**
	 * Source subject ID of the message
	 */
	subjectId!: number;

	/**
	 * Unique token for the message dispatch process
	 */
	dispatchToken!: string;

	/**
	 * The worker ID that reserved the notification
	 */
	leasedBy?: string;

	/**
	 * Timestamp until when the notification is reserved
	 */
	leasedUntil?: Date;

	/**
	 * Timestamp for when the notification was dispatched
	 */
	dispatchedAt?: Date;

	/**
	 * Error message if the notification failed to dispatch
	 */
	dispatchError?: string;
}
